/* eslint-disable
    goodeggs/import-no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import './style';

angular.module(__filename, []).directive(
  'dropoffDayCapacityOverrides',
  ngInject(() => ({
    restrict: 'E',
    scope: {
      overrides: '=ngModel',
    },
    template: require('./template'),
    controllerAs: 'ctrl',
    bindToController: true,
    require: 'ngModel',
    controller: require('./controller').default,
  })),
);

export default __filename;
